import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from 'components/UI';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PricePopper = function PricePopper(_ref) {
  var value = _ref.value,
      euroValue = _ref.euroValue;
  return ___EmotionJSX(Tooltip, {
    noArrow: true,
    placement: "auto",
    strategy: "fixed",
    content: ___EmotionJSX("div", null, ___EmotionJSX("p", null, value), ___EmotionJSX("p", null, euroValue))
  }, ___EmotionJSX(Icon, {
    color: "info",
    iconName: "las la-info-circle",
    size: 24
  }));
};

PricePopper.propTypes = {
  value: PropTypes.string,
  euroValue: PropTypes.string
};
export default PricePopper;